import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

import _ from 'lodash';

@Injectable()
export class SearchService {

	constructor(
		private configService: ConfigService
	) { }

	/**
	 * get searchable fields only from fields.
	 * dataObj is dataObj.fields
	 */
	getSearchableFields(dataObj) {
		const searchableFields = [];
		if (dataObj !== undefined) {
			dataObj.forEach(function (d, i) {
				// can be 'x' for freeform or [prop reference] to array of choices in config service
				if (d.view && d.search) {
					searchableFields.push(d);
				}
			});
		}

		return searchableFields;
	}

	/**
	 * get searchable fields from both fields and objects
	 */
	getAllSearchableFields(dataObj) {
		const configData = this.configService.getDataObj(dataObj);
		const searchableFields = this.getSearchableFields(configData.fields);

		// Nested Object Level 1
		const allObjs = configData.objects;
		if (allObjs !== undefined) {
			allObjs.forEach((obj) => {
				const objFields = obj.fields;
				if (objFields !== undefined) {
					objFields.forEach((objField) => {
						const newObjField = _.cloneDeep(objField);
						newObjField.prop = obj.prop + '.' + objField.prop;
						if (objField.view && objField.search) {
							searchableFields.push(newObjField);
						}
					});
				}
			});
		}
		// tableFields.sort(this.sortFields);
		return searchableFields;
	}
}
